import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import propTypes from "@styled-system/prop-types";
import { space, layout, typography } from "styled-system";

const AvatarStatus = styled("div", {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  position: absolute;
  bottom: 0;
  right: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em;
  
  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const AvatarImage = styled("img", {
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  width: 100%;
  height: auto;
  border-radius: 50em;
  
  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

const Avatar = styled("div", {
  size: PropTypes.oneOf(["", "sm", "lg", "xl"]),
  shape: PropTypes.oneOf(["", "rounded", "square"]),
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.typography,
})`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50em;
  width: 36px;
  height: 36px;
  font-size: 14.4px;
  
  ${AvatarStatus} {
    width: 10px;
    height: 10px;
  }
  
  ${({ size }) => size === "sm" && css`
    width: 24px;
    height: 24px;
    font-size: 9.6px;

    ${AvatarStatus} {
      width: 8px;
      height: 8px;
    }
  `}

  ${({ size }) => size === "lg" && css`
    width: 48px;
    height: 48px;
    font-size: 19.2px;

    ${AvatarStatus} {
      width: 12px;
      height: 12px;
    }
  `}

  ${({ size }) => size === "xl" && css`
    width: 64px;
    height: 64px;
    font-size: 25.6px;

    ${AvatarStatus} {
      width: 14px;
      height: 14px;
    }
  `}

  ${({ shape }) => shape === "rounded" && css`
    border-radius: 4px;
  `}

  ${({ shape }) => shape === "square" && css`
    border-radius: 0;
  `}
  
  /* Style system support */
  ${space}
  ${layout}
  ${typography}
`;

export { AvatarStatus, AvatarImage };

export default Avatar;
